<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="$emit('cancel')">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
      <div class="flex items-start gap-4 mb-6">
        <div class="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-yellow-600">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
            <path d="M12 9v4"></path>
            <path d="M12 17h.01"></path>
          </svg>
        </div>
        <div class="flex-1">
          <h3 class="text-lg font-semibold text-gray-900 mb-2">检测到未完成的测试</h3>
          <p class="text-gray-600 text-sm mb-4">
            检测到本地保存的未完成测试，已回答 <span class="font-semibold text-psychology-primary">{{ progressInfo.answeredCount }}</span> 道题。
            请选择继续作答或重新开始。
          </p>
        </div>
      </div>

      <!-- 进度信息 -->
      <div class="bg-gray-50 rounded-lg p-4 mb-6">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm text-gray-600">答题进度</span>
          <span class="text-sm font-medium">{{ progressInfo.answeredCount }}/{{ progressInfo.totalQuestions }} 题</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2 mb-2">
          <div 
            class="h-2 rounded-full transition-all duration-300"
            :style="{ width: progressInfo.progress + '%', background: 'linear-gradient(to right, var(--psychology-primary), var(--psychology-secondary))' }"
          ></div>
        </div>
        <div class="text-xs text-gray-500">
          开始时间：{{ formatTime(progressInfo.startTime) }}
        </div>
      </div>

      <!-- 按钮组 -->
      <div class="flex gap-3">
        <button 
          @click="handleRestart"
          class="flex-1 btn-secondary"
        >
          重新开始
        </button>
        <button 
          @click="handleContinue"
          class="flex-1 btn-primary"
        >
          继续作答
        </button>
      </div>

      <!-- 提示信息 -->
      <div class="mt-4 text-xs text-gray-500 text-center">
        重新开始将清除当前进度，继续作答将恢复之前的答题状态
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncompleteSessionDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    progressInfo: {
      type: Object,
      required: true
    }
  },
  emits: ['continue', 'restart', 'cancel'],
  methods: {
    handleContinue() {
      this.$emit('continue')
    },
    handleRestart() {
      this.$emit('restart')
    },
    formatTime(timestamp) {
      if (!timestamp) return '未知'
      const date = new Date(timestamp)
      return date.toLocaleString('zh-CN', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes zoom-in {
  from {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
  }
}

.animate-in {
  animation: fade-in 0.2s ease-out, zoom-in 0.2s ease-out;
}
</style>
